export const rejectionReasons = {
  text: [
    { title: "Inappropriate language", description: "" },
    { title: "Violent or disturbing content", description: "" },
    { title: "Mentions drugs, alcohol etc.", description: "" },
    { title: "Promotes negative behavior or attitudes", description: "" },
    { title: "Lacks age-appropriate structure or language", description: "" },
    { title: "Inconsistent or illogical storyline", description: "" },
    { title: "Missing positive message or moral", description: "" },
  ],
  image: [
    {
      title: "Deviation from character gallery",
      description:
        "When a character looks differently than the character gallery dictates. For example, Winnie the Pooh without pawprints, Pete the cat with a mouth, Hook with a red coat.",
    },
    {
      title: "Distorted character",
      description:
        "A character has a physical deformity. For example, Eeyore with only two legs, Pooh with three eyes.",
    },
    {
      title: "Unexplained/duplicate character",
      description:
        "A character shows up in an image that was not called for in the story.",
    },
    {
      title: "Inconsistent/distorted story prop",
      description:
        "A story prop that is inconsistent across frames within a story.",
    },
    {
      title: "Inappropriate prop",
      description:
        "When an item that is inappropriate for a child appears in a story (gun, for example).",
    },
    {
      title: "Unexplained/duplicate story prop",
      description:
        "A story prop that doesn't belong in the image and distracts from the story.",
    },
    {
      title: "Problematic setting",
      description:
        "Something is wrong with the setting. For example, an image inside the house that should be outside, a sky that is supposed to be without stars that has stars.",
    },
  ],
  mask: [
    {
      title: "Incorrect area masked on the main character",
      description: "E.g., only face without hair, or only hair without face",
    },
    {
      title: "Incorrect mask shape on the main character",
      description:
        "E.g., not all long hair is captured, part of the head is covered by other body parts, entire character is selected instead of just the head, or ears are missing from the mask",
    },
    {
      title: "Unnecessary mask not on the main character",
      description:
        "E.g., additional objects are selected along with the character creating “hanging pixels”, or another character is selected together with the main character’s head and hair",
    },
  ],
};
